import "./index.less";

import React, { useMemo } from "react";
import AppVersion from "@/enum/AppVersion";
import ShopType from "@/enum/ShopType";
import { openUrl } from "@/utils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router";
import renewalTipImageSrcMapping from "./renewalTipImageSrcMapping";
import { getSubscribeUrl } from "@/services/subscribeServices";

/**
 * 获取提示图片地址
 */
function getRenewTipImgUrl(shopType: ShopType, showPremiumVersion?: boolean) {
    let src;

    if (shopType === ShopType.KWAI) {
        src = renewalTipImageSrcMapping[ShopType.KWAI][AppVersion.BASE];
    } else {
        const version = showPremiumVersion ? AppVersion.PREMIUM : AppVersion.BASE;

        src = renewalTipImageSrcMapping[shopType][version];
    }

    return src;
}

function getTipText(shopType: ShopType) {
    /** 没有版本之分的使用文案1 */
    const text1 = "订购前请先确认订购页面登录的右上角账号，以防续错店铺";
    const text2 = "①请确认右上角的登录店铺是否为您需要续订的店铺;\n②请确认订购的版本是否为您需要续订的版本;";

    const text = [
        ShopType.TAOBAO,
        ShopType.TAOBAO_DISTRIBUTION,
        ShopType.PINDUODUO,
        ShopType.DOUDIAN,
        ShopType.DOUDIAN_IOP,
        ShopType.DOUDIAN_SUPPLIER,
        ShopType.KWAI_DROPSHIP,
        ShopType.ALIBABA,
        ShopType.JD,
        ShopType.JD_PURCHASE,
    ].includes(shopType)
        ? text2
        : text1;

    return text;
}

interface RenewalConfirmPageWithShopInfoProps {}

/**
 * 订阅确认提示页面，提示用户不要订错店铺和版本
 *
 * 会在页面的query中传入 shop_type show_premium等相关信息
 */
const RenewalConfirmPageWithShopInfo: React.FC<RenewalConfirmPageWithShopInfoProps> = React.memo(function (props) {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const shopType = searchParams.get("shop_type") as ShopType;
    const showPremiumVersion = searchParams.get("show_premium") && ![ShopType.KWAI, ShopType.JD].includes(shopType);

    const tipText = useMemo(() => getTipText(shopType), [shopType]);

    const tipUrl = useMemo(() => getRenewTipImgUrl(shopType, showPremiumVersion), [shopType, showPremiumVersion]);

    return (
        <div className="renewal-confirm-page">
            <div className="renewal-confirm-content">
                <h1>
                    <ExclamationCircleOutlined className="error mr5" />
                    提示
                </h1>
                <div className="tip-text-container error">
                    <span>进入订购页面后:</span>
                    <p className="tip-text">{tipText}</p>
                </div>

                <img className="tip-image" src={tipUrl} alt="" style={{ width: "100%" }} />

                <div className="renewal-confirm-footer">
                    <div>
                        {showPremiumVersion ? (
                            <span className="ml10 fb">
                                <span>续费版本:</span>
                                <span className="error">高级版</span>
                            </span>
                        ) : null}
                    </div>

                    <div>
                        <button
                            className="confirm-button"
                            onClick={() => {
                                const url = getSubscribeUrl(shopType);

                                if (url) {
                                    openUrl(url);
                                }
                            }}
                        >
                            点击前往订购
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default RenewalConfirmPageWithShopInfo;
